<template>
  <div>
    <editor 
      v-model="editorValue" 
      :init="init" 
      :disabled="disabled" 
      @onClick="onClick"></editor>
  </div>
</template>
<script >
import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver";
// import Bus from "@/JS/Bus"; 
// 编辑器插件plugins
// 更多插件参考：https://www.tiny.cloud/docs/plugins/
import "tinymce/plugins/image"; // 插入上传图片插件
import "tinymce/plugins/media"; // 插入视频插件
import "tinymce/plugins/table"; // 插入表格插件
import "tinymce/plugins/lists"; // 列表插件bdmap
import "tinymce/plugins/wordcount"; // 字数统计插件
import "tinymce/plugins/code"; // 查看源码
import "tinymce/plugins/emoticons"; // 表情图标
import "tinymce/plugins/link"; //超链接
import "tinymce/plugins/preview"; //预览
import "tinymce/plugins/advlist";
import "tinymce/plugins/anchor";
import "tinymce/plugins/template";
import "tinymce/plugins/hr";
export default {
  components: {
    Editor
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default:
        "lists image media table wordcount code  link preview formatpainter template checklist hr formatpainter emoticons  "
    },
    toolbar: {
      type: [String, Array],
      default:
        "undo redo | fontselect fontsizeselect hr | blockquote removeformat formatpainter  | link unlink openlink  emoticons | table   code |  bold  italic  underline strikethrough forecolor backcolor   |   alignleft aligncenter alignright alignjustify alignnone   | bullist numlist indent outdent  checklist    formatpainter    | subscript superscript |   formatselect  | lists image   insertvideo insertmusic   insertcard   preview "

    }
  },
  data() {
    return {
      init: {
        language_url: "/static/tinymce/langs/zh_CN.js", //public目录下
        language: "zh_CN",
        skin_url: "/static/tinymce/skins/ui/oxide", //public目录下
        width: 200,
        height: 300,
        //code_dialog_height:200,
        // dialog_width: 600,
        plugins: this.plugins, // 父组件传入 或者 填写个默认的插件 要选用什么插件都可以 去官网可以查到
        toolbar: this.toolbar, // 工具栏 我用到的也就是lists image media table wordcount 这些 根据需求而定
        // images_upload_url: "", //上传路径
        menubar: false, //最上方menu
        // inline: false, //
        statusbar: false, //状态栏
        forced_root_block : false,
        // protect:[" "],
        // toolbar_drawer: false, //工具栏浮动
        // fontsize_formats: "10px 11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 24px 28px 32px 36px",
        //配置字体
        // font_formats: "默认='Helvetica Neue', Helvetica, 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;Optima-Regular(中文细体)=Optima-Regular, PingFangTC-light;Arial=arial,helvetica,sans-serif;Zapfino=Zapfino;Futura-Medium=Futura-Medium;MarkerFelt-Thin=MarkerFelt-Thin;Cochin-BoldItalic=Cochin-BoldItalic;CourierNewPS-ItalicMT=", //'微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif',
        //配置表情
        // emoticons_database_url: "/static/tinymce/plugins/emoticons/js/emojis.js",
        // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
        // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        
        // 官网抄的图片上传 项目如果用了vue-resource可以用$http 因为比较懒就没改
        images_upload_handler: async (blobInfo, success, failure) => {
          const img = 'data:image/jpeg;base64,' + blobInfo.base64()
		      success(img)
        }
      },
      editorValue: this.value
    };
  },
  created() {
  },
  mounted() {
    tinymce.init({})
  },
  methods: {
	    // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
	    // 需要什么事件可以自己增加
	    onClick (e) {
	      // this.$emit('onClick', e, tinymce)
	      // this.$emit('onClick', this.editorValue)
	    },
	    // 可以添加一些自己的自定义事件，如清空内容
	    clear () {
	      this.editorValue = ''
	    }
	},
	watch: {
	  value (newValue,value) {
      // debugger
      this.editorValue = newValue;
	  },
	  editorValue (newValue) {
      this.$emit('input', newValue);
	  }
	}
};
</script>

<style lang="less" scoped>

</style>